const routers = [
    {
        path: '/personal_center',
        name: 'personal_center',
        meta: {
            exp: '个人中心',
            requireAuth: true
        },
        redirect: '/personal_center/homepage',
        component: () => import('@/views/peronsal_center/index.vue'),
        children: [
           
            {
                path: '/personal_center/homepage_care',
                name: 'homepage_care',
                meta: {
                    exp: '个人主页-关注的人',
                    requireAuth: true
                },
                component: () => import('@/views/peronsal_center/care/index.vue'),
            },
            {
                path: '/personal_center/homepage_like',
                name: 'homepage_like',
                meta: {
                    exp: '个人主页-赞过',
                    requireAuth: true
                },
                component: () => import('@/views/peronsal_center/like/index.vue'),
            },
           
         
            {
                path: '/personal_center/account',
                name: 'personal_center_account',
                meta: {
                    exp: '账号信息',
                    requireAuth: true
                },
                component: () => import('@/views/peronsal_center/account/index.vue'),
            },
            {
                path: '/personal_center/safe',
                name: 'personal_center_safe',
                meta: {
                    exp: '账号安全',
                    requireAuth: true
                },
                component: () => import('@/views/peronsal_center/safe/index.vue'),
                redirect: '/personal_center/safe/account_safe',
                children: [
                    {
                        path: '/personal_center/safe/account_safe',
                        name: 'personal_center_account_safe',
                        meta: {
                            exp: '账号安全',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/safe/account_safe/index.vue'),
                    },
                    {
                        path: '/personal_center/safe/change_password',
                        name: 'personal_center_change_password',
                        meta: {
                            exp: '账号安全-修改密码',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/safe/change_password/index.vue'),
                    },
                    {
                        path: '/personal_center/safe/phone_binding',
                        name: 'personal_center_phone_binding',
                        meta: {
                            exp: '账号安全-绑定手机',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/safe/phone_binding/index.vue'),
                    },
                    {
                        path: '/personal_center/safe/mail_binding',
                        name: 'personal_center_mail_binding',
                        meta: {
                            exp: '账号安全-绑定邮箱',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/safe/mail_binding/index.vue'),
                    },
                    {
                        path: '/personal_center/safe/QQ_binding',
                        name: 'personal_center_QQ_binding',
                        meta: {
                            exp: '账号安全-QQ绑定',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/safe/QQ_binding/index.vue'),
                    },
                ]
            },
        ]
    },
   
]
export default routers
